import COLORS from "common/Colors";
import React from "react";
import { UploadOutlined } from "@ant-design/icons";
import { useDropzone } from "react-dropzone";
import styled from "styled-components";

const StyledDropzone = styled.div`
  text-align: center;
  padding: 20px;
  width: 100%;
  margin: auto;
  height: 300px;
  background: #e3e3e3;
  border-radius: 5px;
  .anticon {
    padding-top: 5rem;
  }
  .message {
    font-size: 1rem;
    padding-top: 1rem;
    color: ${COLORS.GREY};
  }
  .upload-icon {
    font-size: 3rem;
    color: ${COLORS.GREY};
  }
`;

const Dropzone = ({ onDrop, accept, fileName, access }) => {
  // Convert accept string to proper format for react-dropzone
  const getAcceptObject = () => {
    if (!accept) return { "image/*": [] };

    const acceptString =
      typeof accept === "string" ? accept : accept.toString();
    const acceptObject = {};

    // Handle image types
    if (
      acceptString.includes("image/*") ||
      acceptString.includes(".jpg") ||
      acceptString.includes(".jpeg") ||
      acceptString.includes(".png")
    ) {
      acceptObject["image/*"] = [];
    }

    // Handle PDF
    if (acceptString.includes(".pdf")) {
      acceptObject["application/pdf"] = [];
    }

    // Handle Excel files
    if (acceptString.includes(".xls") || acceptString.includes(".xlsx")) {
      acceptObject["application/vnd.ms-excel"] = [];
      acceptObject[
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      ] = [];
    }

    // Handle Word documents
    if (acceptString.includes(".doc") || acceptString.includes(".docx")) {
      acceptObject["application/msword"] = [];
      acceptObject[
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
      ] = [];
    }

    // Handle text files
    if (acceptString.includes(".txt")) {
      acceptObject["text/plain"] = [];
    }

    // Handle PowerPoint
    if (acceptString.includes(".ppt")) {
      acceptObject["application/vnd.ms-powerpoint"] = [];
    }

    // Handle CSV
    if (acceptString.includes(".csv")) {
      acceptObject["text/csv"] = [];
    }

    // Handle video files
    if (acceptString.includes(".avi") || acceptString.includes(".mov")) {
      acceptObject["video/*"] = [];
    }

    // Handle ZIP files
    if (acceptString.includes(".zip")) {
      acceptObject["application/zip"] = [];
    }

    return acceptObject;
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: getAcceptObject(),
    disabled: !access,
    noClick: false,
    noKeyboard: false,
  });

  return (
    <>
      <StyledDropzone className="dropzone-div" {...getRootProps()}>
        {access ? (
          <input
            type="file"
            className="dropzone-input"
            accept={accept}
            {...(accept && accept.toString().includes("image")
              ? { capture: "environment" }
              : {})}
            {...getInputProps()}
          />
        ) : null}
        <div className="text-center">
          {isDragActive ? (
            <p className="dropzone-content">Release to drop the files here</p>
          ) : (
            <p className="dropzone-content">
              <UploadOutlined className="upload-icon" />
              <div className="message">
                {navigator.userAgent !== "application"
                  ? access
                    ? "Drag and drop documents here"
                    : "Upload Permission not allowed"
                  : "Upload documents"}
              </div>
              <div>{fileName}</div>
            </p>
          )}
        </div>
      </StyledDropzone>
    </>
  );
};

export default Dropzone;
